module.exports = __webpack_public_path__ + "static/media/gr.71452bbd.svg";